/**
 * The Results tab's member filter (ISSUE-1293), after v1's multi-select
 * GroupMemberList: check any members, or none for All members. A
 * multi-select with its own semantics, so it uses the shared `Checkbox`
 * rows rather than the single-select list.
 */
import { Button, Checkbox, Dialog } from "@sportsmet/ui";
import { type ReactNode, useEffect, useState } from "react";

import {
  STRIP_RESULTS_APPLY_LABEL,
  STRIP_RESULTS_CLEAR_LABEL,
  STRIP_RESULTS_PICK_MEMBERS_TITLE,
} from "./stripCardCopy";

export const StripMembersFilterSheet = (props: {
  open: boolean;
  members: readonly { userId: string; displayName: string }[];
  selected: readonly string[];
  onClose: () => void;
  onApply: (userIds: string[]) => void;
}): ReactNode => {
  const [checked, setChecked] = useState<string[]>([...props.selected]);

  useEffect(() => {
    if (props.open) setChecked([...props.selected]);
  }, [props.open]);

  return (
    <Dialog
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onClose();
      }}
      title={STRIP_RESULTS_PICK_MEMBERS_TITLE}
      autoFocus={false}
      footer={
        <>
          <Button
            variant="secondary"
            data-testid="strip-results-members-clear"
            onClick={() => {
              props.onApply([]);
              props.onClose();
            }}
          >
            {STRIP_RESULTS_CLEAR_LABEL}
          </Button>
          <Button
            variant="primary"
            data-testid="strip-results-members-apply"
            onClick={() => {
              props.onApply(checked);
              props.onClose();
            }}
          >
            {STRIP_RESULTS_APPLY_LABEL}
          </Button>
        </>
      }
    >
      <div
        className="flex flex-col gap-1"
        data-testid="strip-results-members-sheet"
      >
        {props.members.map((member) => (
          <Checkbox
            key={member.userId}
            label={member.displayName}
            checked={checked.includes(member.userId)}
            onCheckedChange={(next) => {
              setChecked((current) =>
                next === true
                  ? [
                      ...current.filter((id) => id !== member.userId),
                      member.userId,
                    ]
                  : current.filter((id) => id !== member.userId),
              );
            }}
          />
        ))}
      </div>
    </Dialog>
  );
};
